import { render } from "./M2InflationChart.vue?vue&type=template&id=b3670d60"
import script from "./M2InflationChart.vue?vue&type=script&lang=js"
export * from "./M2InflationChart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__